import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Styles } from '../../css/table';
import { TablePagination } from '../common/table/tablePagination';
import { userPlanColumn } from '../common/table/TableColumns/userPlan';

const UserPlansTable = ({ pageCount, fetchData }) => {
  const { userPlans } = useSelector(state => state.userPlans);
  return (
    <div className="w-full h-full">
      <Styles>
        <TablePagination
          columns={userPlanColumn}
          data={userPlans?.data || []}
          total_item={userPlans?.total_items}
          fetchData={fetchData}
          pageCount={pageCount}
          className="rounded"
        />
      </Styles>
    </div>
  );
};
UserPlansTable.propTypes = {
  onPageLimitChange: PropTypes.func,
  fetchData: PropTypes.func,
  pageCount: PropTypes.number,
};
export default UserPlansTable;
